import { createIcon } from '@chakra-ui/icons'

const JSONIcon = createIcon({
  viewBox: '0 0 800 1000',
  path: (
    <>
      <path
        d="M27.81 996C14.68 996 4 985.32 4 972.19V364.04h792v605.64c0 14.52-11.81 26.32-26.32 26.32H27.81Z"
        fill="#fff"
      />
      <path
        d="M792 368.04v601.64c0 12.31-10.01 22.32-22.32 22.32H27.81C16.88 992 8 983.11 8 972.19V368.04h784m8-8H0v612.15C0 987.55 12.45 1000 27.81 1000h741.87c16.75 0 30.32-13.58 30.32-30.32V360.04Z"
        fill="#e9ebf1"
      />
      <path
        d="M800 369.45H0V30.12C0 13.49 13.49 0 30.12 0h540.14l125.47 111.83L800 204.36v165.09Z"
        fill="#9d75ab"
      />
      <path
        d="M570.26 0v153.81c0 27.92 22.63 50.55 50.55 50.55H800L570.26 0Z"
        opacity=".5"
        fill="#fff"
      />
      <text
        transform="translate(57.7 245.05)"
        fontFamily="Roboto-Regular,Roboto"
        fontSize="150px"
        fill="#fff"
      >
        <tspan x="0" y="0">
          JSON
        </tspan>
      </text>
      <path
        d="M574.8 602.86c0 9.59-.07 19.18.01 28.77.17 19.26 10.87 30.97 30.06 33.02 8.7.93 14.52 5.68 15.59 12.91 1.06 7.25-1.73 12.77-8.18 16.1-2.15 1.11-4.82 1.34-7.29 1.73-20.55 3.18-30.12 14.16-30.19 34.86-.07 19.18.26 38.37-.11 57.54-.52 26.66-20.76 46.99-45.78 46.54-8.69-.16-14.79-5.22-15.9-13.19-.98-7.06 3.91-13.86 11.75-16.33 18.12-5.72 19.31-7.36 19.31-26.71 0-15.51.35-31.04-.09-46.54-.51-18.38 4.51-34.51 17.67-47.6 3.38-3.36 2.4-5.39-.44-8.25-11.9-12.02-17.41-26.56-17.18-43.51.24-17.48.07-34.97.02-52.46-.04-16.34-2.67-19.68-18.53-23.9-8.33-2.21-13.42-9.08-12.34-16.67 1.18-8.35 6.87-13.24 15.69-13.47 24.09-.62 44.96 20.11 45.8 45.84.34 10.42.06 20.87.06 31.31h.06Zm-309.42-1.07c0-10.72-.37-21.46.07-32.16 1.01-24.43 22.29-44.61 45.87-43.92 8.62.25 14.2 5.02 15.06 12.87.95 8.63-3.24 14.87-11.53 17.18-17.29 4.83-18.89 6.96-18.9 25.21-.01 17.5-.03 34.99-.04 52.49-.02 16.25-5.42 30.45-16.88 41.97-3.84 3.86-3.11 6.01.26 9.56 10.71 11.25 16.5 24.72 16.56 40.42.07 18.91.04 37.81.11 56.72.05 14.58 3.31 18.68 17.47 22.34 10.31 2.66 14.39 8.5 12.83 18.34-1.22 7.73-7.04 11.68-16.94 11.5-23.76-.42-43.35-20.14-43.91-44.86-.43-18.9-.11-37.81-.12-56.72-.01-23.75-8.61-33.79-32.1-37.51-8.44-1.33-13.48-6.63-13.76-14.45-.3-8.5 5.17-14.71 14.12-16.02 22.84-3.35 31.72-13.62 31.74-36.72v-26.24h.08Zm170.39 147.8c0 7.06.3 14.13-.07 21.16-.59 11.02-6.6 17.48-15.66 17.5-9.07.02-15.34-6.45-15.66-17.41-.41-14.1-.38-28.23-.02-42.33.27-10.52 6.18-16.6 15.18-16.76 9.35-.17 15.02 5.01 15.99 15.84.65 7.28.12 14.66.12 22h.12Zm-15.63-146.27c13.21.05 22.91 9.75 22.79 22.81-.12 12.54-10.76 23.2-23.08 23.1-12.73-.1-22.77-10.41-22.71-23.31.07-13.24 9.64-22.65 22.99-22.6Z"
        fill="#e9ebf1"
      />
    </>
  ),
})

export default JSONIcon
